import React, { FC, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';

import Form, { Item, RequiredRule } from 'devextreme-react/form';
//devextreem
import { Popup } from 'devextreme-react/popup';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppFieldBox } from 'components/appComponents';
import ModalFooter from 'components/appModalFooter';
import { DateBox, SelectBox } from 'devextreme-react';

import { useChangeRequestStatusMutation } from 'bus/request';
import { StatusChangeData, StatusItem } from 'bus/request/types';

const initialForm = {
  id: 0,
  status: 0,
  postponedDate: new Date(),
};

type StatusChangeModalRoleProps = {
  id: number | null | string;
  refresh: () => void;
  status: number | null | string;
  visible: boolean;
  onHiding: () => void;
  requestStatusDataList?: StatusItem[];
};

const StatusChangeModalRole: FC<StatusChangeModalRoleProps> = (props) => {
  const [changeRequestStatus, { isLoading }] = useChangeRequestStatusMutation();

  let createStatusChangeGroupRef = useRef<Form>(null);
  let createStatusChangeGroupValidationRef = useRef<ValidationGroup>(null);
  let timeRef = useRef<DateBox | null>(null);

  let { id } = useParams<{ id: string }>();

  const [form, setForm] = useState<StatusChangeData>(initialForm);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault && e.preventDefault();

    changeRequestStatus(form)
      .unwrap()
      .then(() => {
        props.refresh();
        props.onHiding();
        toast.success('Статус успешно изменён', {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      });
  };

  useEffect(() => {
    setForm((prev) => ({ ...prev, id: id, status: props.status }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onShown = () => {
    setForm((prev) => ({ ...prev, status: props.status }));
  };

  return (
    <div>
      <Popup
        visible={props.visible}
        onHiding={props.onHiding}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Смена статуса"
        width={400}
        onShowing={onShown}
        height={360}
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit} id="status">
              <ValidationGroup ref={createStatusChangeGroupValidationRef}>
                <Form id="test-transport" formData={form} ref={createStatusChangeGroupRef}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppFieldBox label="Статус" labelTop>
                      <SelectBox
                        stylingMode="underlined"
                        placeholder="Выберите тип"
                        mode="text"
                        value={form.status}
                        onValueChange={(e) => {
                          setForm((prev) => ({ ...prev, status: e }));
                        }}
                        displayExpr="name"
                        valueExpr="id"
                        dataSource={props.requestStatusDataList}
                      >
                        <Validator>
                          <RequiredRule message="Заполните поле тип" />
                        </Validator>
                      </SelectBox>
                    </AppFieldBox>

                    {String(form.status) === String(6) ? (
                      <>
                        <AppFieldBox label="Дата" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            value={form.postponedDate}
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, postponedDate: e }));
                              timeRef.current?.instance.focus();
                            }}
                            dateSerializationFormat="yyyy-MM-ddTHH:mm:ssx"
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле время" />
                            </Validator>
                          </DateBox>
                        </AppFieldBox>

                        <AppFieldBox label="Время" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="time"
                            ref={timeRef}
                            value={form.postponedDate}
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, postponedDate: e }));
                            }}
                            dateSerializationFormat="yyyy-MM-ddTHH:mm:ssx"
                            placeholder="00:00"
                            useMaskBehavior={true}
                            displayFormat="HH:mm"
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле время" />
                            </Validator>
                          </DateBox>
                        </AppFieldBox>
                      </>
                    ) : null}
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={props.onHiding}
                  textConfirm="Сохранить"
                  typeConfirm="default"
                  disabledSubmit={isLoading}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default StatusChangeModalRole;
